import { render, staticRenderFns } from "./delete-conversation-message-model.vue?vue&type=template&id=c167f116&"
import script from "./delete-conversation-message-model.vue?vue&type=script&lang=js&"
export * from "./delete-conversation-message-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports